export default __webpack_public_path__ + "static/media/boxingBanner.636cd910.jpg";